module.exports = __webpack_public_path__ + "img/part4-uIcon13.bf60765a.png";